var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "config-hidden",
              rawName: "v-config-hidden",
              value: _vm.makeConfig("test.productNumber"),
              expression: "makeConfig('test.productNumber')"
            }
          ],
          staticClass: "row my-1"
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "config-required",
                  rawName: "v-config-required",
                  value: _vm.makeConfig("test.productNumber"),
                  expression: "makeConfig('test.productNumber')"
                }
              ],
              staticClass: "col-2"
            },
            [_vm._v(_vm._s(_vm.$t("productQualityTests.test.productNumber")))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-10" }, [
            _c("input", {
              directives: [
                {
                  name: "config-required",
                  rawName: "v-config-required",
                  value: _vm.makeConfig("test.productNumber"),
                  expression: "makeConfig('test.productNumber')"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text", disabled: "disabled" },
              domProps: { value: _vm.productNumber }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "config-hidden",
              rawName: "v-config-hidden",
              value: _vm.makeConfig("test.productName"),
              expression: "makeConfig('test.productName')"
            }
          ],
          staticClass: "row my-1"
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "config-required",
                  rawName: "v-config-required",
                  value: _vm.makeConfig("test.productName"),
                  expression: "makeConfig('test.productName')"
                }
              ],
              staticClass: "col-2"
            },
            [_vm._v(_vm._s(_vm.$t("productQualityTests.test.productName")))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-10" }, [
            _c("input", {
              directives: [
                {
                  name: "config-required",
                  rawName: "v-config-required",
                  value: _vm.makeConfig("test.productName"),
                  expression: "makeConfig('test.productName')"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text", disabled: "disabled" },
              domProps: { value: _vm.product.name }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "config-hidden",
              rawName: "v-config-hidden",
              value: _vm.makeConfig("test.testDate"),
              expression: "makeConfig('test.testDate')"
            }
          ],
          staticClass: "row my-1"
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "config-required",
                  rawName: "v-config-required",
                  value: _vm.makeConfig("test.testDate"),
                  expression: "makeConfig('test.testDate')"
                }
              ],
              staticClass: "col-2"
            },
            [_vm._v(_vm._s(_vm.$t("productQualityTests.test.date")))]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-10" },
            [
              _c("Datepicker", {
                attrs: {
                  "monday-first": true,
                  language: _vm.datepickerDE,
                  "bootstrap-styling": true,
                  disabled: !_vm.editable
                },
                model: {
                  value: _vm.test.testDate,
                  callback: function($$v) {
                    _vm.$set(_vm.test, "testDate", $$v)
                  },
                  expression: "test.testDate"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "config-hidden",
              rawName: "v-config-hidden",
              value: _vm.makeConfig("test.protocolNumber"),
              expression: "makeConfig('test.protocolNumber')"
            }
          ],
          staticClass: "row my-1"
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "config-required",
                  rawName: "v-config-required",
                  value: _vm.makeConfig("test.protocolNumber"),
                  expression: "makeConfig('test.protocolNumber')"
                }
              ],
              staticClass: "col-2"
            },
            [_vm._v(_vm._s(_vm.$t("productQualityTests.test.protocolNumber")))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-10" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.test.protocolNumber,
                  expression: "test.protocolNumber"
                },
                {
                  name: "config-required",
                  rawName: "v-config-required",
                  value: _vm.makeConfig("test.protocolNumber"),
                  expression: "makeConfig('test.protocolNumber')"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text", disabled: !_vm.editable },
              domProps: { value: _vm.test.protocolNumber },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.test, "protocolNumber", $event.target.value)
                }
              }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "config-hidden",
              rawName: "v-config-hidden",
              value: _vm.makeConfig("test.testPerson"),
              expression: "makeConfig('test.testPerson')"
            }
          ],
          staticClass: "row my-1"
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "config-required",
                  rawName: "v-config-required",
                  value: _vm.makeConfig("test.testPerson"),
                  expression: "makeConfig('test.testPerson')"
                }
              ],
              staticClass: "col-2"
            },
            [_vm._v(_vm._s(_vm.$t("productQualityTests.test.tester")))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-10" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.test.testPerson,
                  expression: "test.testPerson"
                },
                {
                  name: "config-required",
                  rawName: "v-config-required",
                  value: _vm.makeConfig("test.testPerson"),
                  expression: "makeConfig('test.testPerson')"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text", disabled: !_vm.editable },
              domProps: { value: _vm.test.testPerson },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.test, "testPerson", $event.target.value)
                }
              }
            })
          ])
        ]
      ),
      _vm._v(" "),
      !_vm.test.measurementSpecifications.length
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "config-hidden",
                  rawName: "v-config-hidden",
                  value: _vm.makeConfig("test.error"),
                  expression: "makeConfig('test.error')"
                }
              ],
              staticClass: "row my-1"
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "config-required",
                      rawName: "v-config-required",
                      value: _vm.makeConfig("test.error"),
                      expression: "makeConfig('test.error')"
                    }
                  ],
                  staticClass: "col-2"
                },
                [_vm._v(_vm._s(_vm.$t("productQualityTests.test.range")))]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-3" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.test.testSpecification,
                      expression: "test.testSpecification"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", disabled: "disabled" },
                  domProps: { value: _vm.test.testSpecification },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.test,
                        "testSpecification",
                        $event.target.value
                      )
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-3" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.test.expectedError,
                      expression: "test.expectedError"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", disabled: "disabled" },
                  domProps: { value: _vm.test.expectedError },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.test, "expectedError", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-4" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.test.error,
                      expression: "test.error"
                    },
                    {
                      name: "config-required",
                      rawName: "v-config-required",
                      value: _vm.makeConfig("test.error"),
                      expression: "makeConfig('test.error')"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", disabled: !_vm.editable },
                  domProps: { value: _vm.test.error },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.test, "error", $event.target.value)
                    }
                  }
                })
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "config-hidden",
              rawName: "v-config-hidden",
              value: _vm.makeConfig("test.grade"),
              expression: "makeConfig('test.grade')"
            }
          ],
          staticClass: "row my-1"
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "config-required",
                  rawName: "v-config-required",
                  value: _vm.makeConfig("test.grade"),
                  expression: "makeConfig('test.grade')"
                }
              ],
              staticClass: "col-2"
            },
            [_vm._v(_vm._s(_vm.$t("productQualityTests.test.assesment")))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-10" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.test.grade,
                  expression: "test.grade"
                },
                {
                  name: "config-required",
                  rawName: "v-config-required",
                  value: _vm.makeConfig("test.grade"),
                  expression: "makeConfig('test.grade')"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text", disabled: !_vm.editable },
              domProps: { value: _vm.test.grade },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.test, "grade", $event.target.value)
                }
              }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "config-hidden",
              rawName: "v-config-hidden",
              value: _vm.makeConfig("test.note"),
              expression: "makeConfig('test.note')"
            }
          ],
          staticClass: "row my-1"
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "config-required",
                  rawName: "v-config-required",
                  value: _vm.makeConfig("test.note"),
                  expression: "makeConfig('test.note')"
                }
              ],
              staticClass: "col-2"
            },
            [_vm._v(_vm._s(_vm.$t("productQualityTests.test.note")))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-10" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.test.note,
                  expression: "test.note"
                },
                {
                  name: "config-required",
                  rawName: "v-config-required",
                  value: _vm.makeConfig("test.note"),
                  expression: "makeConfig('test.note')"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text", disabled: !_vm.editable },
              domProps: { value: _vm.test.note },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.test, "note", $event.target.value)
                }
              }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "config-hidden",
              rawName: "v-config-hidden",
              value: _vm.makeConfig("test.weight"),
              expression: "makeConfig('test.weight')"
            }
          ],
          staticClass: "row my-1"
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "config-required",
                  rawName: "v-config-required",
                  value: _vm.makeConfig("test.weight"),
                  expression: "makeConfig('test.weight')"
                }
              ],
              staticClass: "col-2"
            },
            [_vm._v(_vm._s(_vm.$t("productQualityTests.test.weight")))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-10 input-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.test.weight,
                  expression: "test.weight",
                  modifiers: { number: true }
                },
                {
                  name: "config-required",
                  rawName: "v-config-required",
                  value: _vm.makeConfig("test.weight"),
                  expression: "makeConfig('test.weight')"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "number", disabled: !_vm.editable },
              domProps: { value: _vm.test.weight },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.test, "weight", _vm._n($event.target.value))
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            }),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.test.weightUnit,
                    expression: "test.weightUnit"
                  },
                  {
                    name: "config-required",
                    rawName: "v-config-required",
                    value: _vm.makeConfig("test.weightUnit"),
                    expression: "makeConfig('test.weightUnit')"
                  }
                ],
                staticClass: "form-control",
                staticStyle: { "max-width": "16em" },
                attrs: { disabled: !_vm.editable },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.test,
                      "weightUnit",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  }
                }
              },
              _vm._l(_vm.weightUnits, function(unit) {
                return _c("option", { key: unit, domProps: { value: unit } }, [
                  _vm._v(_vm._s(unit))
                ])
              }),
              0
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "config-hidden",
              rawName: "v-config-hidden",
              value: _vm.makeConfig("test.batchNumber"),
              expression: "makeConfig('test.batchNumber')"
            }
          ],
          staticClass: "row my-1"
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "config-required",
                  rawName: "v-config-required",
                  value: _vm.makeConfig("test.batchNumber"),
                  expression: "makeConfig('test.batchNumber')"
                }
              ],
              staticClass: "col-2"
            },
            [_vm._v(_vm._s(_vm.$t("productQualityTests.test.batchNumber")))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-10" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.test.batchNumber,
                  expression: "test.batchNumber"
                },
                {
                  name: "config-required",
                  rawName: "v-config-required",
                  value: _vm.makeConfig("test.batchNumber"),
                  expression: "makeConfig('test.batchNumber')"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text", disabled: !_vm.editable },
              domProps: { value: _vm.test.batchNumber },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.test, "batchNumber", $event.target.value)
                }
              }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row my-1" }, [
        _c("div", { staticClass: "col" }, [
          _vm._v(_vm._s(_vm.$t("productQualityTests.test.mandatory")))
        ])
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("PqtMeasurements", { attrs: { test: _vm.test } }),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("image-viewer", {
        attrs: { isShowDelete: _vm.allowMediaDelete, medias: _vm.test.files },
        on: {
          "removed-media": function($event) {
            return _vm.removeMedia($event)
          }
        }
      }),
      _vm._v(" "),
      _c("drop-zone", {
        attrs: { formId: "dz_test" + _vm._uid },
        on: { uploaded: _vm.fileUploaded }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }